import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import bbbRound from "../assets/bbbRound.png"
import google2 from "../assets/google2.png"
import yelp2 from "../assets/yelp2.png"
import HomeProducts from "./ui/homePageProducts"
import axios from "axios"
import { fetchReviews } from "../store"
import { MessageSquare } from "lucide-react"
import HomePageReviews from "./ui/homePageReviews"
import "./styles/Landing.css"

const Landing = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleButtonClick = () => {
    navigate("/contact")
  }

  return (
    <div className="landing">
      <div className="rating-column">
        <img src={bbbRound} alt="BBB Logo" className="header-image" />
        <img src={google2} alt="Google Logo" className="header-image" />
        <img src={yelp2} alt="Yelp Logo" className="header-image" />
      </div>
      <h1 className="intro">Manny&rsquo;s Seamless Gutters, Inc.</h1>
      <p>
        Stands as the premier gutter service provider in New York. Located in
        Nassau County, our combined expertise covers gutter cleaning, repairs,
        and the installation of maintenance-free seamless gutters, including
        gutter guards and screens. No matter if you are an industry pro or a DIY
        enthusiast, we offer everything you would need. With over 15 years of
        experience in the gutter industry, Manny's understand the significance
        of top-tier materials and a custom, seamless fit.
      </p>
      <br />
      <h1 className="intro">We Offer A Variety of Products:</h1>
      <div className="landing-gutter-styles">
        <ul>
          <li>K-Style Gutters</li>
          <li>Gutter Guards</li>
          <li>Leaders</li>
          <li>Soffits</li>
          <li>Downspouts</li>
          <li>Downspout Strainers</li>
        </ul>
      </div>
      <div className="commitment">
        <p>
          We&rsquo;re honored to serve a wide range of areas, including over 300
          towns and neighborhoods in New York, Nassau & Suffolk County, and Long
          Island. We are also no stranger to the Tri-State Area, including
          Conneticut and Northern New Jersey. We&rsquo;re committed to providing
          the best gutter solutions for your home or business.
        </p>
        <br />

        <p>
          We prioritize the safety and quality of our work. Whether you&rsquo;re
          inquiring about an estimate, repair, installation, or cleaning,
          we&rsquo;re committed to upholding the highest safety standards. No
          job is too big or too small for us.
        </p>
        <br />

        <p>
          Since 2018, we&rsquo;ve been dedicated to providing tailored seamless
          gutter solutions. Beyond that, we offer installation, repair, and
          maintenance services for rain gutters, downspouts, leaders, and
          extensions, catering to both residential and commercial as far as the
          Tri-State Area. We aim to help you protect your property, eliminating
          the need for you to climb up ladders and take risks.
        </p>
        <br />

        <p>
          If you&rsquo;re looking for reliable seamless gutter solutions,
          we&rsquo;re here to assist. Reliable gutter services begins with just
          a call to Manny&rsquo;s Seamless Gutters, Inc.
        </p>
      </div>

      <div className="landing-quote">
        <p className="contactus">Bonded & Insured</p>
        <button className="landing-quote-btn" onClick={handleButtonClick}>
          <MessageSquare size={32} />
          Book Online Now!
        </button>
        <p className="contactus">Free Consultations</p>
      </div>
      <div className="services-container">
        <div className="service-item">
          <h2>Residential Cleaning</h2>
          <p>
            Our residential gutter cleaning service is specialized in ensuring
            that your home&rsquo;s gutters are free from debris and blockages.
            Proper gutter cleaning helps prevent water damage and ensures the
            longevity of your gutter system. Trust us to keep your home safe
            from water-related issues.
          </p>
        </div>

        <div className="service-item">
          <h2>Commercial Cleaning</h2>
          <p>
            Our commercial gutter cleaning service is tailored for businesses
            and commercial buildings. We specialize in thorough gutter cleaning
            with our specialized boom trucks and scissor lifts to maintain the
            integrity of your commercial property and prevent potential issues.
          </p>
        </div>

        <div className="service-item">
          <h2>Gutter Repairs</h2>
          <p>
            We offer a comprehensive range of gutter repair services, including
            fascia, soffit, and gutter repairs. Our skilled team can fix issues
            such as leaks, sagging, and damaged components. Ensure your gutters
            function properly with our efficient repair solutions.
          </p>
        </div>

        <div className="service-item">
          <h2>Gutter Installations</h2>
          <p>
            When it comes to gutter installations, we specialize in seamless
            gutter systems. Our installations provide a custom fit that ensures
            efficient water drainage. Upgrade your property with our seamless
            gutter installation services.
          </p>
        </div>

        {/* <div className="service-item">
          <h2>Copper Gutters</h2>
          <p>
            Discover the elegance and durability of copper gutters. We offer
            copper gutter installation and repair services. Copper gutters not
            only enhance the aesthetics of your property but also provide
            long-lasting performance. Trust us for all your copper gutter needs.
          </p>
        </div> */}

        <div className="service-item">
          <h2>Downspouts</h2>
          <p>
            Our downspout services include cleaning and repair. Downspouts are
            essential for directing water away from your property&rsquo;s
            foundation. Ensure your downspouts are functioning correctly to
            prevent water damage.
          </p>
        </div>

        <div className="service-item">
          <h2>Gutter Leaders</h2>
          <p>
            Gutter leaders play a vital role in proper water drainage. We
            provide installation and repair services for gutter leaders to
            ensure efficient water flow. Protect your property from
            water-related issues with our gutter leader solutions.
          </p>
        </div>

        <div className="service-item">
          <h2>Gutter Leaf Guards</h2>
          <p>
            Our gutter leaf guard services include installation and replacement.
            Keep leaves and debris out of your gutters with our effective guard
            and cover solutions. Prevent clogs and maintain the functionality of
            your gutters with our services.
          </p>
        </div>
      </div>

      <div className="landing-quote">
        <p className="contactus">Bonded & Insured</p>
        <button className="landing-quote-btn" onClick={handleButtonClick}>
          <MessageSquare size={32} />
          Book Online Now!
        </button>
        <p className="contactus">Free Consultations</p>
      </div>
      <HomePageReviews />
    </div>
  )
}

export default Landing
